var _style, _defs, _defs2, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1251.4 170.9",
    style: {
      enableBackground: "new 0 0 1251.4 170.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);fill:#2D6BFF;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M0,128.1h32.6l13-17H0c0-6.3,0.1-12.2,0.2-17.2h58.3l13-17H1C1.6,71,2.6,65.2,4,59.7h80.5l13-17H9.8 c2.4-5.4,5.2-10.2,8.3-14.3C42.3-3.3,87.6-9.4,119.3,14.8C151,39,157.1,84.3,132.9,116c-10.5,13.8-33.2,25.6-57,34 c-13.5,4.8-75.6,20.9-75.6,20.9S0,150,0,128.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -398.4,
    y: -491.3,
    width: 2050.5,
    height: 1153.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.3,
    y: -5.3,
    className: "st1",
    width: 158.4,
    height: 181.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1251.4,153.8h-60.1V21.7h58.1v12.2h-43.8v46.8h35.7v12.2h-35.7v48.8h45.9V153.8z M1139.9,98.9V86.7h37.1v67.1 h-6.1l-5.3-13c-2.9,4.9-6.6,8.8-11.2,11.7c-4.6,2.9-9.6,4.4-15.1,4.4c-19.7,0-29.6-9.5-29.6-28.5V47.1c0-9.1,2.8-16.1,8.4-21 c5.6-4.9,13.9-7.4,25.1-7.4c11.1,0,19.6,2.5,25.3,7.4c5.7,4.9,8.6,12,8.6,21v11.2h-14.3V47.1c0-10.8-6.5-16.3-19.4-16.3 c-12.9,0-19.4,5.4-19.4,16.3v81.3c0,5.2,1.1,9.2,3.3,12c2.2,2.8,6.1,4.3,11.9,4.3s11.1-2.3,16.1-6.9c5-4.6,7.4-9.1,7.4-13.4V98.9 H1139.9z M1038,153.8h-14.3V21.7h14.3l44.2,101.7V21.7h14.3v132.2h-14.3L1038,52.2V153.8z M970.8,37.5l-16.7,73.6h33.4L970.8,37.5z  M960.2,21.7h21.4l30,132.2h-14.3l-6.9-30.5h-38.9l-6.9,30.5h-14.3L960.2,21.7z M863.7,153.8h-14.3V21.7h14.3v59h40.2v-59h14.3 v132.2h-14.3v-61h-40.2V153.8z M822.2,128.4v-11.2h14.3v11.2c0,9.1-2.8,16.1-8.4,21c-5.6,4.9-13.9,7.4-25.1,7.4 c-11.1,0-19.6-2.5-25.3-7.4c-5.7-4.9-8.6-12-8.6-21V47.1c0-9.1,2.8-16.1,8.4-21c5.6-4.9,13.9-7.4,25.1-7.4 c11.1,0,19.6,2.5,25.3,7.4c5.7,4.9,8.6,12,8.6,21v19.3h-14.3V47.1c0-10.8-6.5-16.3-19.4-16.3c-12.9,0-19.4,5.4-19.4,16.3v81.3 c0,10.8,6.5,16.3,19.4,16.3C815.8,144.7,822.2,139.3,822.2,128.4z M761.9,153.8H747l-23-51.4l-23,51.4h-14.9l30.6-68.1l-28.5-64.1 H703l21.8,49.2L747,21.7h14.9l-29.6,65.9L761.9,153.8z M675.9,153.8h-60.1V21.7h58.1v12.2h-43.8v46.8h35.7v12.2h-35.7v48.8h45.9 V153.8z M572.2,153.8h-60.1V21.7h58.1v12.2h-43.8v46.8h35.7v12.2h-35.7v48.8h45.9V153.8z M483.2,128.4v-11.2h14.3v11.2 c0,9.1-2.8,16.1-8.4,21c-5.6,4.9-13.9,7.4-25.1,7.4c-11.1,0-19.6-2.5-25.3-7.4c-5.7-4.9-8.6-12-8.6-21V47.1c0-9.1,2.8-16.1,8.4-21 c5.6-4.9,13.9-7.4,25.1-7.4c11.1,0,19.6,2.5,25.3,7.4c5.7,4.9,8.6,12,8.6,21v19.3h-14.3V47.1c0-10.8-6.5-16.3-19.4-16.3 c-12.9,0-19.4,5.4-19.4,16.3v81.3c0,10.8,6.5,16.3,19.4,16.3C476.8,144.7,483.2,139.3,483.2,128.4z M381.5,37.5l-16.7,73.6h33.4 L381.5,37.5z M370.9,21.7h21.4l30,132.2H408l-6.9-30.5h-38.9l-6.9,30.5H341L370.9,21.7z M279,153.8V21.7h14.3v120h37.3v12.2H279z  M251.4,84.7V50.1c0-5.2-1.6-9.2-4.7-12s-7.6-4.3-13.5-4.3h-16.5V101h16.5C245.3,101,251.4,95.6,251.4,84.7z M216.7,153.8h-14.3 V21.7h30.8c10.6,0,18.6,2.5,24.2,7.5c5.5,5,8.3,12,8.3,20.9v34.6c0,9.1-2.7,16.1-8.2,21c-5.4,4.9-13.5,7.4-24.3,7.4h-16.5V153.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile_logo.8e0c8e4845fa0f33f4b9af4ae7499b5c.svg";
export { ForwardRef as ReactComponent };